/**
 * Test ID utilities for Tabs component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for Tabs container
 * @param identifier - Tabs identifier
 * @returns Test ID string
 */
export const setTabsTestId = (identifier: string): string => generateTestId("Tabs", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for TabsList
 * @param identifier - Tabs identifier
 * @returns Test ID string
 */
export const setTabsListTestId = (identifier: string): string => generateTestId("TabsList", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for TabsTrigger
 * @param value - Tab value (the value prop)
 * @returns Test ID string
 */
export const setTabsTriggerTestId = (value: string): string => generateTestId("TabsTrigger", value.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for TabsContent
 * @param value - Tab value (the value prop)
 * @returns Test ID string
 */
export const setTabsContentTestId = (value: string): string => generateTestId("TabsContent", value.replace(/\s+/g, "-").toLowerCase());
